// extracted by mini-css-extract-plugin
export default {"tableWrapper":"ServicesPage_tableWrapper__Z76tx","oddRow":"ServicesPage_oddRow__f9U6h"};